"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAdditionalInfo = useAdditionalInfo;
var _react = require("react");
var _types = require("../../types");
var _utils = require("../../utils");
function useAdditionalInfo() {
    const [isVouchersDialogOpen, setIsVouchersDialogOpen] = (0, _react.useState)(false);
    const [isBalanceDialogOpen, setIsBalanceDialogOpen] = (0, _react.useState)(false);
    const toggleVouchersDialog = (0, _react.useCallback)(()=>{
        setIsVouchersDialogOpen((prevState)=>!prevState);
    }, [
        setIsVouchersDialogOpen
    ]);
    const toggleBalanceDialog = (0, _react.useCallback)(()=>{
        setIsBalanceDialogOpen((prevState)=>!prevState);
    }, [
        setIsBalanceDialogOpen
    ]);
    const onAccountBalanceClick = (0, _react.useCallback)(()=>{
        toggleBalanceDialog();
        // analytics
        (0, _utils.dispatchUserActionEvent)([
            _types.MetaHierarchy.SelectAccountBalance
        ]);
    }, [
        toggleBalanceDialog
    ]);
    return {
        isVouchersDialogOpen,
        isBalanceDialogOpen,
        toggleVouchersDialog,
        toggleBalanceDialog,
        onAccountBalanceClick
    };
}
